import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import * as echarts from "echarts";
// 强制加载水球图扩展（解决打包丢失问题）
const loadLiquidfill = () => {
    try {
        const liquidfill = require("echarts-liquidfill");
        return liquidfill.default || liquidfill;
    }
    catch (e) {
        console.error("水球图扩展加载失败:", e);
        return null;
    }
};
const liquidfill = loadLiquidfill();
if (liquidfill && typeof liquidfill.install === "function") {
    echarts.use([liquidfill]);
}
// rem适配配置
const REM_CONFIG = {
    chart: {
        size: "1.3rem",
        margin: "0.03rem",
    },
    font: {
        percent: "0.18rem",
        value: "0.18rem",
        amount: "0.18rem",
        label: "0.18rem",
    },
};
const CircleChart = ({ current, radio, cname, color, amount, }) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);
    useEffect(() => {
        if (!chartRef.current || !liquidfill)
            return;
        chartInstance.current = echarts.init(chartRef.current);
        updateChart();
        const handleResize = () => chartInstance.current?.resize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            chartInstance.current?.dispose();
        };
    }, [current, radio, color]);
    const updateChart = () => {
        if (!chartInstance.current)
            return;
        const percentage = radio;
        // 渐变色逻辑
        const waveGradient = new echarts.graphic.LinearGradient(0, 0, // 渐变起点：左上角
        0, 1, // 渐变终点：左下角（垂直方向渐变）
        [
            { offset: 0, color: lightenColor(color, 40) }, // 亮一点的颜色
            { offset: 1, color: color }, // 原始传入颜色
        ]);
        chartInstance.current.setOption({
            title: [
                // 第二个title显示数值
                {
                    text: `${current}${cname === "三剂物资" ? "吨" : "项"}`,
                    x: "center",
                    y: "10%", // 放在百分比下方
                    textStyle: {
                        fontSize: REM_CONFIG.font.amount,
                        color: "#FFFFFF",
                        fontWeight: "bold",
                    },
                },
                // 第一个title显示百分比
                {
                    text: percentage * 100 + "%",
                    x: "center",
                    y: "65%", // 向上移动，为subtext留出空间
                    textStyle: {
                        fontSize: REM_CONFIG.font.percent,
                        color: "#FFFFFF",
                        fontWeight: "bold",
                    },
                },
            ],
            series: [
                {
                    type: "liquidFill",
                    data: [percentage],
                    color: [waveGradient],
                    radius: "100%",
                    label: {
                        show: true,
                        rich: {
                            percent: {
                                fontSize: REM_CONFIG.font.percent, // 适配rem
                                color: "#FFFFFF",
                                fontWeight: "bold",
                                align: "center",
                            },
                            value: {
                                fontSize: REM_CONFIG.font.value, // 适配rem
                                color: "#FFFFFF",
                            },
                        },
                        formatter: `{value|${amount}万元}`,
                    },
                    backgroundStyle: { color: "rgba(255,255,255,0)" },
                    outline: { show: false },
                    waveAnimation: true,
                },
            ],
        });
    };
    // 辅助函数：将颜色调亮
    const lightenColor = (color, percent) => {
        // 解析颜色值
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        // 调亮颜色
        const lighten = (value) => {
            return Math.min(255, Math.round(value + (255 - value) * (percent / 100)));
        };
        // 转换为16进制
        const toHex = (value) => {
            return value.toString(16).padStart(2, "0");
        };
        return `#${toHex(lighten(r))}${toHex(lighten(g))}${toHex(lighten(b))}`;
    };
    return (_jsxs("div", { className: "flex flex-col items-center", children: [_jsx("div", { ref: chartRef, style: {
                    width: REM_CONFIG.chart.size,
                    height: REM_CONFIG.chart.size,
                } }), _jsx("span", { style: {
                    marginTop: REM_CONFIG.chart.margin,
                    color: "#FFFFFF",
                    fontSize: REM_CONFIG.font.label,
                }, children: cname })] }));
};
export default CircleChart;
